
const pages = [
    { text: 'Destinos', url: '/destinos' },
    { text: 'Especiales', utl: '#' },
    { text: 'Blog', url: '/blog' }
]

export default pages;